import type { Control, FieldError, FieldValues, Path } from 'react-hook-form'
import { Controller } from 'react-hook-form'

import { cn } from 'src/shared/utils/cn'

import BusinessFormErrorMessage from './business-form-error-message'

interface BusinessFormFieldControlledProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  placeholder: string
  type: string
  format: (value: string) => string
  autoFocus?: boolean
}

export default function BusinessFormFieldControlled<T extends FieldValues>({
  control,
  name,
  placeholder,
  type,
  format,
  autoFocus = false,
}: BusinessFormFieldControlledProps<T>) {
  return (
    <div className="relative flex w-full flex-col items-center justify-center">
      <Controller
        control={control}
        name={name}
        render={({ field, formState: { errors } }) => (
          <>
            <input
              {...field}
              type={type || 'text'}
              placeholder={placeholder}
              autoComplete="off"
              value={field.value}
              onChange={(e) => {
                const formatted = format(e.target.value)
                field.onChange(formatted)
              }}
              autoFocus={autoFocus}
              className={cn(
                'w-full items-center rounded-full p-[10px] text-center text-[42px] font-bold tracking-[-0.78px] text-primary placeholder:text-[#D8D8D6] focus-visible:outline-none md:text-[52px]',
              )}
            />
            {errors[name] && (
              <div className="absolute bottom-[-20px]">
                <BusinessFormErrorMessage error={errors[name] as FieldError} />
              </div>
            )}
          </>
        )}
      />
    </div>
  )
}
